import React from 'react';
import AdminAnalyticsDashboard from './AdminAnalyticsDashboard';

/**
 * Dashboard principal do administrador
 * Exibe o Dashboard Analítico de Disparos com métricas, insights e análises
 */
const AdminDashboard = () => {
  return <AdminAnalyticsDashboard />;
};

export default AdminDashboard;
